/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "messagebox": {
      "title": "Message",
      "confirm": "OK",
      "cancel": "Cancel",
      "error": "Illegal input"
    }
  },
  "de-DE": {
    "messagebox": {
      "title": "Nachricht",
      "confirm": "OK",
      "cancel": "Abbrechen",
      "error": "Unzulässige Eingabe"
    }
  },
  "es-ES": {
    "messagebox": {
      "title": "Mensaje",
      "confirm": "Aceptar",
      "cancel": "Cancelar",
      "error": "Entrada no permitida"
    }
  },
  "fr-FR": {
    "messagebox": {
      "title": "Message",
      "confirm": "OK",
      "cancel": "Annuler",
      "error": "Entrée illicite"
    }
  },
  "id-ID": {
    "messagebox": {
      "title": "Pesan",
      "confirm": "Oke",
      "cancel": "Batal",
      "error": "Input ilegal"
    }
  },
  "it-IT": {
    "messagebox": {
      "title": "Messaggio",
      "confirm": "OK",
      "cancel": "Annulla",
      "error": "Input non consentito"
    }
  },
  "jp-JP": {
    "messagebox": {
      "title": "メッセージ",
      "confirm": "OK",
      "cancel": "キャンセル",
      "error": "不正な入力"
    }
  },
  "ko-KO": {
    "messagebox": {
      "title": "메시지",
      "confirm": "확인",
      "cancel": "취소",
      "error": "잘못된 입력"
    }
  },
  "nl-NL": {
    "messagebox": {
      "title": "Bericht",
      "confirm": "OK",
      "cancel": "Annuleren",
      "error": "Ongeldige invoer"
    }
  },
  "pl-PL": {
    "messagebox": {
      "title": "Wiadomość",
      "confirm": "OK",
      "cancel": "Anuluj",
      "error": "nieprawidłowe dane wejściowe"
    }
  },
  "pt-PT": {
    "messagebox": {
      "title": "Mensagem",
      "confirm": "OK",
      "cancel": "Cancelar",
      "error": "Entrada ilegal"
    }
  },
  "ru-RU": {
    "messagebox": {
      "title": "Сообщение",
      "confirm": "ОК",
      "cancel": "Отмена",
      "error": "Недействительный ввод"
    }
  },
  "tr-TR": {
    "messagebox": {
      "title": "Mesaj",
      "confirm": "Tamam",
      "cancel": "İptal",
      "error": "Yasal olmayan girdi"
    }
  },
  "vi-VN": {
    "messagebox": {
      "title": "Tin nhắn",
      "confirm": "OK",
      "cancel": "Hủy",
      "error": "Đầu vào không hợp lệ"
    }
  },
  "zh-CN": {
    "messagebox": {
      "title": "消息",
      "confirm": "确定",
      "cancel": "取消",
      "error": "非法输入"
    }
  },
  "zh-TW": {
    "messagebox": {
      "title": "訊息",
      "confirm": "確定",
      "cancel": "取消",
      "error": "不合法的輸入"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
